import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
    Row,
    Col
} from '@sketchpixy/rubix';

export const ContractInfoItemStyle = styled(Row)`
  border-top: 1px solid #d8d8d8;
  align-items: center;
  display: flex;

  & > div {
    font-size: 16px;
    margin-top: auto;
    margin-bottom: auto;
  }
  
  & > div:first-child {
    color: black;
  }
  
  & > div:last-child {
    color: #717171;
  }
`;

class ContractInfoItem extends Component {
  render() {
    const Cont = this.props.styledComponent ? this.props.styledComponent : ContractInfoItemStyle;

    return (
        <Cont>
          <Col xs={4}>{this.props.title}</Col>
          <Col xs={8}>{this.props.sub}</Col>
        </Cont>
    );
  }
}

ContractInfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  sub: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  styledComponent: PropTypes.func,
};

export default ContractInfoItem;



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/EditCard/ContractInfoItem.js